import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from 'react-bootstrap'
import ColorPicker from 'components/ColorPicker'

export class LabelForm extends React.Component {
  static propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    actions: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.renderNameField = this.renderNameField.bind(this)
    this.renderColorField = this.renderColorField.bind(this)
  }

  renderNameField (field) {
    const onInputFocus = (event) => {
      const tempValue = event.target.value
      event.target.value = ''
      event.target.value = tempValue
    }

    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}>
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <FormControl
          {...field.input}
          name={null}
          type='text'
          onFocus={onInputFocus} />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  renderColorField (field) {
    return (
      <FormGroup>
        <ControlLabel><FormattedMessage id='LABEL_COLOR' /></ControlLabel>
        <div>
          <ColorPicker
            value={field.input.value}
            onChange={field.input.onChange}
          />
        </div>
      </FormGroup>
    )
  }

  render () {
    const {
      handleSubmit,
      actions
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderNameField} />
        <Field
          name='color'
          component={this.renderColorField} />
        {actions && actions(this.props)}
      </form>
    )
  }
}

export default reduxForm()(LabelForm)
